import React, { useState } from 'react';
import { BookOpenIcon, FlagIcon, LeafIcon, RotateCcwIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueList } from '../story/DialogueList';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { SavannaScene } from '../art/SavannaScene';
import { AMARA_MENTOR } from '../../data/speakers';
export function FinishScreen() {
  const {
    dispatch,
    world,
    openDialog,
    announce
  } = useDemo();
  const [finished, setFinished] = useState(false);
  const description = `A reed bends near the old pipe. Panther turns one ear. Meerkats stay on the wall.${world.sidePathVisible ? ' The side-water path you opened is still visible.' : ''}`;
  if (finished) {
    return <ScreenContainer width="narrow" data-id="element-167" data-mp="3gz8tdjz3c5b6">
        <div className="rounded-2xl border border-line bg-paper p-8 text-center hc-strong" data-id="element-168" data-mp="29w3g468ha50h">
          <ScreenHeading size="xl" focusKey="finished" data-id="element-169" data-mp="24xa129djm5y7">
            Not perfect. More paths.
          </ScreenHeading>
          <p className="mx-auto mt-4 max-w-prose" data-id="element-170" data-mp="1zxnn1xpw4loc">
            Thanks for playing this demo. The story continues in Garden 1. Your visit is kept while this page stays open.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-171" data-mp="2sml3rwegeaez">
            <Button variant="secondary" onClick={() => setFinished(false)} data-id="element-172" data-mp="2sop649wpf1d5">
              Back to the closing signal
            </Button>
            <Button onClick={() => dispatch({
            type: 'GO',
            screen: 'welcome'
          })} data-id="element-173" data-mp="2iw9nrbhhwarq">Return to the start</Button>
          </div>
        </div>
      </ScreenContainer>;
  }
  return <ScreenContainer data-id="element-174" data-mp="3bd2kt3pxbhki">
      <ScreenHeading eyebrow="Closing signal" data-id="element-175" data-mp="3bedybv9683ot">Two sounds</ScreenHeading>
      <div className="mt-6 grid gap-8 lg:grid-cols-[1.35fr_1fr] lg:items-start" data-id="element-176" data-mp="36mvxd775e33u">
        <SceneIllustration description={description} quietTitle="Closing signal" data-id="element-177" data-mp="36ksw1r0jonjt">
          <SavannaScene world={world} label={description} cliffhanger data-id="element-178" data-mp="14r6kgkx8d4dm" />
        </SceneIllustration>
        <DialogueList lines={[{
        kind: 'sound',
        text: 'A hiss from grass.'
      }, {
        kind: 'sound',
        text: 'A different sound from the Meerkat wall.'
      }, {
        kind: 'speech',
        speaker: AMARA_MENTOR,
        text: 'Today’s science news: not every noise gets the whole throne room in my head.'
      }]} data-id="element-179" data-mp="19q9elabo9q6t" />
      </div>

      <div className="mt-10 rounded-2xl bg-forest p-8 text-cream sm:p-10" data-id="element-180" data-mp="pxuogh7vbd9l">
        <p className="max-w-2xl font-display text-2xl leading-snug sm:text-3xl" data-id="element-181" data-mp="c2926ht0r7kv">
          One sound came from the grass. One came from the group. Which one changed Monkey’s path?
        </p>
        <p className="mt-6 font-display text-4xl font-bold tracking-wide text-gold sm:text-5xl" data-id="element-182" data-mp="26eyxn3z1coud">TWO SOUNDS</p>
        <p className="mt-3 text-cream" data-id="element-183" data-mp="2bcqy4mdqxja6">The story continues in Garden 1.</p>
      </div>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-184" data-mp="3vw2t4lo2zzun">
        <Button variant="secondary" onClick={() => {
        dispatch({
          type: 'REPLAY_ROUTE'
        });
        announce('Route cleared. Choose a next step.');
      }} icon={<RotateCcwIcon size={18} aria-hidden="true" data-id="element-186" data-mp="4oq9lzzq7abk" />} data-id="element-185" data-mp="3qwzy7u1tfa0e">
          Try another route
        </Button>
        <Button variant="secondary" onClick={() => openDialog('fieldGuide')} icon={<BookOpenIcon size={18} aria-hidden="true" data-id="element-188" data-mp="dhtwt006b1je" />} data-id="element-187" data-mp="ifvephlv4uta">
          Open Field Guide
        </Button>
        <Button variant="secondary" onClick={() => dispatch({
        type: 'OPEN_PAUSE'
      })} icon={<LeafIcon size={18} aria-hidden="true" data-id="element-190" data-mp="nf8346sdu9xz" />} data-id="element-189" data-mp="seknmkvs74xe">
          Visit quiet space
        </Button>
        <Button onClick={() => setFinished(true)} icon={<FlagIcon size={18} aria-hidden="true" data-id="element-192" data-mp="2u8bjb6lec2v7" />} data-id="element-191" data-mp="2u5flrjdgng7a">
          Finish demo
        </Button>
      </ActionRow>
    </ScreenContainer>;
}